/**
 * ChatArea Component
 * 
 * Scrollable message list container with iMessage-style bubbles.
 * Each message gets its own bubble (self + others).
 * 
 * Updated December 11, 2025 (Issue #608): Removed giant card wrapper,
 * using individual ChatMessageRow components for each message.
 */

import { type Message } from './ChatMessage';
import { ChatMessageRow } from './ChatMessageRow';
import { NoMessagesEmptyState } from './EmptyStatePresets';

interface ChatAreaProps {
  messages: Message[];
  onScroll?: (isScrolled: boolean) => void;
  onSendMessage?: () => void;
}

export default function ChatArea({ messages, onScroll, onSendMessage }: ChatAreaProps) {
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const scrollTop = e.currentTarget.scrollTop;
    onScroll?.(scrollTop > 20);
  };

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center px-4 bg-oro-bg">
        <NoMessagesEmptyState 
          variant="compact"
          onAction={onSendMessage}
        />
      </div>
    );
  }

  return (
    <div 
      className="flex-1 py-4 bg-oro-bg"
      onScroll={handleScroll}
    >
      {messages.map((message) => (
        <ChatMessageRow
          key={message.id}
          message={message}
          isOwn={message.type === 'self'}
        />
      ))}
    </div>
  );
}
